import React from "react";

const About = () => {
  return (
    <div>
      <h2>About Us</h2>
      <p>
        We are one of the oldest Computer & Laptop dealers in the Mathikere area, 
        specializing in wholesale distribution of new laptops, desktops, imported and 
        open-box laptops, refurbished laptops, and rental laptops. We have been serving 
        Bangalore city for the last 12 years. 
      </p>
      <p>
        In addition to computers, we also deal with security systems like CCTV, 
        bio-metric systems, and other IT accessories. Our trained staff provides 
        expert sales and service support for computers, laptops, and desktops.
      </p>
    </div>
  );
};

export default About;
